import React, { useContext } from "react";

// Context //
import TalentsContext from "../../../contexts/talentsContext";

// Styles //
import "./talentsAvailable.scss";

const TalentsAvailable = () => {
    const { currentTotal } = useContext(TalentsContext);
    return (
        <div className="talent-available">
            <h2>
                <span>{currentTotal < 10 ? `0${currentTotal}` : currentTotal}</span>
                Talentos disponibles
            </h2>
        </div>
    );
};

export default TalentsAvailable;
